// Overlay state (M11; absorbed into the M7 shell's layer model): the blocking overlay (ErrorScreen >
// ContextLostOverlay / ElsewhereOverlay), the RotateOverlay (landscape) and the non-blocking one-time
// Add-to-Home-Screen card (one flag, meta.uiFlags.a2hs). Plain signals the shell (ui/state.ts) re-exports.
import { signal } from '@preact/signals';

export type BlockingOverlay =
  | { k: 'none' }
  | { k: 'contextLost'; text: string; onTap(): void }
  | { k: 'elsewhere'; text: string; button: string; onPlayHere(): void }
  | { k: 'error'; title: string; detail: string; reload: string | null; onReload(): void };

export interface A2hsView {
  text: string;
  button: string;
  onDismiss(): void;
}

export const blockingSig = signal<BlockingOverlay>({ k: 'none' });
export const a2hsSig = signal<A2hsView | null>(null);
/**
 * M7 RotateOverlay (UX §1.6): a phone held in landscape — the text "Rotate to portrait", or null. It blocks
 * input (the sim keeps running) but gives way to the blocking overlays above.
 */
export const rotateSig = signal<string | null>(null);

/** Shows `o` unless an ErrorScreen is up (it stays: nothing works behind it). */
export function showBlocking(o: BlockingOverlay): void {
  if (blockingSig.value.k === 'error' && o.k !== 'error') return;
  blockingSig.value = o;
}
